import { createContext } from 'react';

/**
 * WorkspaceContext maintains the global state for the active workspace context.
 * It contains activeWorkspace, isLoading, error, and their respective setters.
 */
export const WorkspaceContext = createContext(null);

export default WorkspaceContext;
